'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var divider = require('./divider.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var itemSpacing = 0.5;
var parts = ['item', 'command', 'list', 'button', 'group', 'groupTitle', 'divider'];
var baseStyleList = {
  bg: 'white',
  boxShadow: 'md',
  minW: '2xs',
  py: '2',
  zIndex: 1,
  borderRadius: 'default',
  p: 2,
  '& > *:not(style)~*:not(style)': {
    mt: itemSpacing
  }
};
var baseStyleItem = {
  py: 2.5,
  px: 3.5,
  transitionProperty: 'background',
  transitionDuration: 'ultra-fast',
  transitionTimingFunction: 'ease-in',
  _hover: {
    fontWeight: 'semibold'
  },
  _focus: {
    fontWeight: 'semibold'
  },
  _active: {
    fontWeight: 'semibold',
    bg: 'gray.100'
  },
  _checked: {
    fontWeight: 'semibold',
    bg: 'gray.100'
  },
  _expanded: {
    bg: 'gray.100'
  },
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed'
  }
};
var baseStyleGroup = {
  '& > *:not(style)~*:not(style)': {
    mt: itemSpacing
  }
};
var baseStyleGroupTitle = {
  px: 3.5,
  py: 2.5,
  fontWeight: 'semibold',
  fontSize: 'sm',
  color: 'gray.400'
};
var baseStyleCommand = {
  opacity: 0.6
};
var baseStyleDivider = _objectSpread(_objectSpread({
  border: 0,
  borderBottom: '1px solid',
  borderColor: 'inherit',
  my: itemSpacing
}, divider["default"].baseStyle), {}, {
  opacity: 0.5
});
var baseStyleButton = {
  transitionProperty: 'common',
  transitionDuration: 'normal'
};
var baseStyle = {
  button: baseStyleButton,
  list: baseStyleList,
  item: baseStyleItem,
  group: baseStyleGroup,
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider
};
var Menu = {
  parts: parts,
  baseStyle: baseStyle
};
exports["default"] = Menu;